<form [formGroup]="formulario">
  <div class="row">
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>ID</mat-label>
        <input formControlName="id" matInput readonly>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Nome</mat-label>
        <input formControlName="name" matInput minlength="3" maxlength="50" required>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Estoque</mat-label>
        <input formControlName="stockQuantity" matInput required>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Situação</mat-label>
        <mat-select formControlName="active" required>
          <mat-option value="true">Ativo</mat-option>
          <mat-option value="false">Inativo</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Cód do Produto</mat-label>
        <input maxlength="13" formControlName="productMaster" mask="separator.0" matInput (change)="buscarProduto.emit()">
      </mat-form-field>
    </div>
    <div class="col-10">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Produto Principal</mat-label>
        <input matInput [value]="nameProduct" disabled>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Custo</mat-label>
        <span matPrefix>R$&nbsp;</span>
        <input matInput formControlName="cost" mask="separator.2" thousandSeparator="." required>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Venda Portaria</mat-label>
        <span matPrefix>R$&nbsp;</span>
        <input matInput formControlName="pricePort" mask="separator.2" thousandSeparator="." required>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Venda Entrega</mat-label>
        <span matPrefix>R$&nbsp;</span>
        <input matInput formControlName="price" mask="separator.2" thousandSeparator="." required>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Venda A Prazo</mat-label>
        <span matPrefix>R$&nbsp;</span>
        <input matInput formControlName="priceReceivable" mask="separator.2" thousandSeparator="." required>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-2"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>cEAN</mat-label><input matInput formControlName="cean" maxlength="13"></mat-form-field></div>
    <div class="col-2"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>NCM</mat-label><input matInput formControlName="ncm" maxlength="12"></mat-form-field></div>
    <div class="col-2"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>CEST</mat-label><input matInput formControlName="cest" maxlength="12"></mat-form-field></div>
    <div class="col-2"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>CFOP</mat-label><input matInput formControlName="cfop" maxlength="4"></mat-form-field></div>
    <div class="col-2"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>cEANTrib</mat-label><input matInput formControlName="ceanTrib" maxlength="13"></mat-form-field></div>
    <div class="col-2"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>Benefício Fiscal</mat-label><input matInput formControlName="cbenef" maxlength="20"></mat-form-field></div>
  </div>
  <div class="row">
    <div class="col-4">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Unidade Comercial</mat-label>
        <mat-select formControlName="unidadeComercial" required>
          <mat-option value="GALAO">GALÃO</mat-option><mat-option value="KG">QUILOGRAMA</mat-option>
          <mat-option value="LATA">LATA</mat-option><mat-option value="LITRO">LITRO</mat-option>
          <mat-option value="M">METRO</mat-option><mat-option value="PC">PEÇA</mat-option>
          <mat-option value="POTE">POTE</mat-option><mat-option value="SACO">SACO</mat-option>
          <mat-option value="UNID">UNIDADE</mat-option><mat-option value="VASIL">VASILHAME</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Unidade Tributária</mat-label>
        <mat-select formControlName="unidadeTributaria" required>
          <mat-option value="GALAO">GALÃO</mat-option><mat-option value="KG">QUILOGRAMA</mat-option>
          <mat-option value="LATA">LATA</mat-option><mat-option value="LITRO">LITRO</mat-option>
          <mat-option value="M">METRO</mat-option><mat-option value="PC">PEÇA</mat-option>
          <mat-option value="POTE">POTE</mat-option><mat-option value="SACO">SACO</mat-option>
          <mat-option value="UNID">UNIDADE</mat-option><mat-option value="VASIL">VASILHAME</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Vínculo Adicional</mat-label>
        <mat-select formControlName="vinculoAdicional" required>
          <mat-option value="NENHUM">NENHUM</mat-option>
          <mat-option value="GLP">Gás GLP</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row" *ngIf="formulario.value.vinculoAdicional == 'GLP'">
    <div class="col-3"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>% GLP petróleo</mat-label><input matInput formControlName="pglp"></mat-form-field></div>
    <div class="col-3"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>% Gás Natural Nacional</mat-label><input matInput formControlName="pgNn"></mat-form-field></div>
    <div class="col-3"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>% Gás Natural Importado</mat-label><input matInput formControlName="pgNi"></mat-form-field></div>
    <div class="col-3"><mat-form-field class="full-width w-100" appearance="fill"><mat-label>Valor de partida</mat-label><input matInput formControlName="valorPart"></mat-form-field></div>
  </div>
</form>
